import { render, staticRenderFns } from "./ProductsView.vue?vue&type=template&id=2bc611ec&scoped=true"
import script from "./ProductsView.vue?vue&type=script&lang=js"
export * from "./ProductsView.vue?vue&type=script&lang=js"
import style0 from "./ProductsView.vue?vue&type=style&index=0&id=2bc611ec&prod&scoped=true&lang=css"
import style1 from "./ProductsView.vue?vue&type=style&index=1&id=2bc611ec&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc611ec",
  null
  
)

export default component.exports